
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24Android = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  cx: 15.375,
  cy: 14.625,
  r: 1.125
}), /*#__PURE__*/React.createElement("circle", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  cx: 8.625,
  cy: 14.625,
  r: 1.125
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.25 18v-2.144c0-5.389 4.327-9.837 9.716-9.856a9.75 9.75 0 0 1 9.784 9.75V18a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75zM3 5.25l2.913 2.913M21 5.25l-2.897 2.897",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

      const __svgRaw = "<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g transform=\"translate(.5)\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M0 0h24v24H0z\"/>\r\n        <circle fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" cx=\"15.375\" cy=\"14.625\" r=\"1.125\"/>\r\n        <circle fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" cx=\"8.625\" cy=\"14.625\" r=\"1.125\"/>\r\n        <path d=\"M2.25 18v-2.144c0-5.389 4.327-9.837 9.716-9.856a9.75 9.75 0 0 1 9.784 9.75V18a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75zM3 5.25l2.913 2.913M21 5.25l-2.897 2.897\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-android.613572b03fcf02e382db6dc6ee861496.svg"),
        {
          React: SvgIcon24Android,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      